import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// Bridges the Edit Profile page's just-uploaded/just-loaded photo to the
// header avatar, which lives in a sibling component (default-layout) that
// isn't otherwise notified when the profile page's own image resolves —
// without this, the header kept showing whatever was cached at login until
// a full page reload, even right after successfully saving a new photo.
@Injectable({ providedIn: 'root' })
export class UserImageService {
  private imageSubject = new BehaviorSubject<string | null>(null);
  image$ = this.imageSubject.asObservable();

  setImage(dataUrl: string | null): void {
    if (dataUrl) {
      this.imageSubject.next(dataUrl);
    }
  }
}
